/**
 * Module dependencies.
 */

import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { queryKeys } from 'src/core/constants/query-keys';
import { ExtendedAxiosConfig, axiosInstance, getApiEndpoint } from 'src/core/utils/requests';
import { NormalizedSettingsProfileOptions, SettingsProfileOptions } from 'src/types/settings';

/**
 * Export `getSettingsProfileOptions` request.
 */

export async function getSettingsProfileOptions(
  options?: ExtendedAxiosConfig
): Promise<NormalizedSettingsProfileOptions> {
  const response = await axiosInstance.get(getApiEndpoint('getUserSettings'), options);

  return Object.entries(response.data as SettingsProfileOptions).reduce(
    (acc, [key, items]) => ({
      ...acc,
      [key]: items.map(label => ({ label, value: label }))
    }),
    {}
  ) as NormalizedSettingsProfileOptions;
}

/**
 * Export `useSettingsProfileOptions` hook.
 */

export function useSettingsProfileOptions(
  options?: Omit<UseQueryOptions<NormalizedSettingsProfileOptions>, 'queryFn' | 'queryKey'>
) {
  return useQuery({
    queryFn: () => getSettingsProfileOptions(),
    queryKey: queryKeys.settingsOptions,
    ...options
  });
}
